import React, { useState } from 'react';
import LoginTemplate from '../templates/LoginTemplate/LoginTemplate';
import useAuth from '../hooks/useAuth';

const LoginScreen = () => {
  const [credentials, setCredentials] = useState({ 
    email: '', 
    password: '' 
  });
  
  const { login, isLoading, error } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(credentials);
  };

  return (
    <div className="login-screen">
      <LoginTemplate
        credentials={credentials}
        onChangeHandler={handleChange}
        onSubmitHandler={handleSubmit}
        errorMessage={error}
        isLoading={isLoading}
      />
    </div>
  );
};

export default LoginScreen;